import React, {useEffect, useState} from "react";
import {FaArrowDown, FaArrowUp, FaMedal, FaMinus, FaTrophy} from 'react-icons/fa';
import {Link} from 'react-router-dom';

export const Ranking = () => {
    const [podio, setPodio] = useState([]);
    const [classificacao, setClassificacao] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const carregarRanking = async () => {
            try {
                const response = await fetch('/api/Ranking');
                if (!response.ok) {
                    throw new Error('Erro ao carregar ranking');
                }
                const data = await response.json();

                setPodio(data.slice(0, 3));
                setClassificacao(data);
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };

        carregarRanking();
    }, []);

    const renderPodio = () => {
        if (loading) return <p>Carregando ranking...</p>;
        if (podio.length < 3) return <p className="text-muted">Ainda não há dados suficientes para o pódio.</p>;

        const [primeiro, segundo, terceiro] = [podio[0], podio[1], podio[2]];

        return (
            <div className="mb-5">
                <h2 className="text-center fw-bold mb-4">Pódio</h2>
                <div className="row align-items-end justify-content-center g-3">
                    <div className="col-12 col-sm-6 col-md-4 order-2 order-md-1">
                        <div className="card bg-dark-subtle text-center shadow-sm h-100 mt-md-4">
                            <div className="card-body py-4">
                                <FaMedal size={40} className="text-secondary mb-3"/>
                                <h4 className="mb-2 fw-bold text-secondary">{segundo.posicao}º</h4>
                                <h5 className="card-title fw-bold">{segundo.nome}</h5>
                                <h3 className="text-primary fw-bold">{segundo.pontos}</h3>
                                <p className="text-muted mb-0">pontos</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 order-1 order-md-2">
                        <div className="card bg-warning-subtle text-center shadow-lg h-100 border-warning">
                            <div className="card-body py-4">
                                <FaTrophy size={60} className="text-warning mb-3"/>
                                <h3 className="mb-2 fw-bold text-warning">{primeiro.posicao}º</h3>
                                <h4 className="card-title fw-bold">{primeiro.nome}</h4>
                                <h2 className="text-primary fw-bold">{primeiro.pontos}</h2>
                                <p className="text-muted mb-0">pontos</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 order-3">
                        <div className="card bg-danger-subtle text-center shadow-sm h-100 mt-md-4">
                            <div className="card-body py-4">
                                <FaMedal size={40} className="text-danger mb-3"/>
                                <h4 className="mb-2 fw-bold text-danger">{terceiro.posicao}º</h4>
                                <h5 className="card-title fw-bold">{terceiro.nome}</h5>
                                <h3 className="text-primary fw-bold">{terceiro.pontos}</h3>
                                <p className="text-muted mb-0">pontos</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderClassificacao = () => {
        if (loading) return <p>Carregando classificação...</p>;
        if (!classificacao.length) return <p className="text-muted">Nenhum jogador no ranking ainda.</p>;

        const iconeTendencia = (tendencia) => {
            if (tendencia === 'alta') return <FaArrowUp className="text-success"/>;
            if (tendencia === 'baixa') return <FaArrowDown className="text-danger"/>;
            return <FaMinus className="text-muted"/>;
        };

        const bgPosicao = (posicao) => {
            if (posicao === 1) return 'bg-warning-subtle';
            if (posicao === 2) return 'bg-dark-subtle';
            if (posicao === 3) return 'bg-danger-subtle';
            return '';
        };

        const textoPosicao = (posicao) => {
            if (posicao === 1) return 'text-warning';
            if (posicao === 2) return 'text-secondary';
            if (posicao === 3) return 'text-danger';
            return '';
        };

        return (
            <div className="mb-2">
                <h4>Classificação completa</h4>
                {classificacao.map(jogador => {
                    const aproveitamento = jogador.jogos
                        ? ((jogador.vitorias / jogador.jogos) * 100).toFixed(1)
                        : '0';

                    return (
                        <Link key={jogador.posicao}
                              to={`/jogador/${jogador.id}`}
                              className="text-decoration-none">
                            <div className={`card mb-2 shadow-sm ${bgPosicao(jogador.posicao)}`}
                                 style={{cursor: 'pointer'}}>
                                <div className="card-body">
                                    <div className="d-flex align-items-start">
                                        <div className="me-3 text-center align-self-center" style={{minWidth: '2.5rem'}}>
                                            <h4 className={`mb-0 fw-bold ${textoPosicao(jogador.posicao)}`}>
                                                {jogador.posicao}º
                                            </h4>
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div className="d-flex flex-column justify-content-between">
                                                    <div className="d-flex gap-2">
                                                        <h5 className="mb-0 fw-bold">{jogador.nome}</h5>
                                                        <div className="text-center">
                                                            {iconeTendencia(jogador.tendencia)}
                                                        </div>
                                                    </div>
                                                    <div className="text-muted small">
                                                        <span className="me-3">{jogador.jogos} jogos</span>
                                                        <span className="me-3">{jogador.vitorias} vitórias</span>
                                                        <span>{aproveitamento}% aproveitamento</span>
                                                    </div>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="text-end">
                                                        <h5 className="mb-0 text-primary fw-bold">{jogador.pontos}</h5>
                                                        <small className="text-muted">pontos</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        );
    };

    const renderInformacoesPontuacao = () => (
        <div className="card bg-info-subtle shadow-sm mb-4">
            <div className="card-body">
                <h4 className="card-title">Como funciona a pontuação</h4>
                <ul className="list-unstyled">
                    <li>• <strong>Presença:</strong> 30 pontos por participar</li>
                    <li>• <strong>Vitória:</strong> +30 pontos</li>
                    <li>• <strong>Derrota:</strong> +10 pontos</li>
                    <li>• <strong>Saldo de games:</strong> (ganhos - perdidos) × 2</li>
                    {/*<li>• <strong>Bônus melhor saldo do dia:</strong> +20 pontos</li>
                    <li>• <strong>Bônus mais vitórias do dia:</strong> +20 pontos</li>*/}
                </ul>
            </div>
        </div>
    );

    return (
        <div className="container">
            {renderPodio()}
            {renderClassificacao()}
            {renderInformacoesPontuacao()}
        </div>
    );
};